export default (apiMethods, endpoints) => ({
    getUserStatistics: () => {
        return apiMethods.get(endpoints.GET_STATISTICS_FOR_USER);
    },
    getStatisticsByDomainSuperAdmin: (domainId) => {
        return apiMethods.get(endpoints.GET_STATISTICS_BY_DOMAIN_SUPER_ADMIN_ENDPOINT + '/' + domainId);
    },
    getStatisticsByCategory: (categoryId) => {
        return apiMethods.get(endpoints.GET_STATISTICS_BY_CATEGORY_ENDPOINT + '/' + categoryId);
    },
    getStatisticsByDomainByDays: (domainId, from, until) => {
        return apiMethods.get(endpoints.GET_STATISTICS_BY_DOMAIN_BY_DAYS_ENDPOINT(domainId, from, until));
    },
    getStatisticsByProduct: (productId) => {
        return apiMethods.get(endpoints.GET_STATISTICS_BY_PRODUCT_ENDPOINT + '/' + productId);
    },
    getStatisticsByStory: (storyId) => {
        return apiMethods.get(endpoints.GET_STATISTICS_BY_STORY_ENDPOINT + '/' + storyId);
    },
    getTimelineByProduct: (productId) => {
        return apiMethods.get(endpoints.GET_TIMELINE_BY_PRODUCT_ENDPOINT + '/' + productId);
    },
    getLogStatistics: (options) => {
        return apiMethods.post(endpoints.GET_LOG_STATISTICS_ENDPOINT, options);
    },
    //
    getLogStatisticsSuperAdmin: (options) => {
        return apiMethods.post(endpoints.GET_LOG_STATISTICS_SUPER_ADMIN_ENDPOINT, options);
    },
    getLogTypes: () => {
        return apiMethods.get(endpoints.GET_LOG_TYPES_ENDPOINT);
    }
})



// WEBPACK FOOTER //
// ./src/lib/api-statistics.js